<template>
  <div id="app" calss="app">
    <router-view />
    <el-backtop :bottom="100"></el-backtop>
  </div>
</template>

<script>
import ScaleBox from "@/components/ScaleBox/Scale-Box.vue";
export default {
  components: {
    ScaleBox,
  },
};
</script>
<style lang="scss">
#app {
  color: #181818;
  // overflow: hidden;
}
html,
body,
#app {
  margin: 0;
  padding: 0;
  // position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
body {
  // overflow-x: hidden;
}
</style>
